import React, { useState, useEffect } from 'react';
import EligibilityCheckSection from './components/EligibilityCheckSection';
import ApplicationFormSection from './components/ApplicationFormSection';
import ProgressIndicatorSection from './components/ProgressIndicatorSection';
import FooterSection from '../HomePage/components/FooterSection';
import Navigation from '../../components/ui/Navigation';
import LanguageToggle from '../../components/ui/LanguageToggle';

const ApplyPage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('EN');
  const [currentStep, setCurrentStep] = useState('eligibility'); // 'eligibility' or 'application'
  const [isEligible, setIsEligible] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('creditFixerLanguage');
    if (savedLanguage && (savedLanguage === 'EN' || savedLanguage === 'FR')) {
      setCurrentLanguage(savedLanguage);
    }

    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail?.language);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  const handleEligibilityComplete = (eligible) => {
    setIsEligible(eligible);
    if (eligible) {
      setCurrentStep('application');
    }
  };

  const content = {
    EN: {
      title: currentStep === 'eligibility' ? "Check Your Eligibility" : "Complete Your Application",
      subtitle: currentStep === 'eligibility' 
        ? "See if you qualify for a PSPXpress card in just a few minutes"
        : "You\'re eligible! Complete your application to get your card"
    },
    FR: {
      title: currentStep === 'eligibility' ? "Vérifiez votre admissibilité" : "Complétez votre demande",
      subtitle: currentStep === 'eligibility'
        ? "Voyez si vous êtes admissible à une carte PSPXpress en quelques minutes" :"Vous êtes admissible! Complétez votre demande pour obtenir votre carte"
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <div className="min-h-screen bg-background">
      {/* Language Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle 
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageChange}
        />
      </div>

      {/* Navigation */}
      <Navigation currentLanguage={currentLanguage} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-primary to-blue-800">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {text?.title}
          </h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto">
            {text?.subtitle}
          </p>
        </div>
      </section>

      {/* Progress Indicator */}
      <ProgressIndicatorSection 
        currentStep={currentStep}
        currentLanguage={currentLanguage}
      />

      {/* Main Content */}
      {currentStep === 'eligibility' ? (
        <EligibilityCheckSection 
          currentLanguage={currentLanguage}
          onEligibilityComplete={handleEligibilityComplete}
        />
      ) : (
        <ApplicationFormSection 
          currentLanguage={currentLanguage}
          isEligible={isEligible}
        />
      )}

      {/* Footer */}
      <FooterSection currentLanguage={currentLanguage} />
    </div>
  );
};

export default ApplyPage;